<template>
  <div>
    <div class="animated revealUp">
      <div class="white-wrapper">
        <div class="section-title mb-4">{{ $t("transactions") }}</div>
        <div class="mt-3 mb-4">
          <div class="row">
            <!-- SELECT DROPDOWN -->
            <div class="col-lg-4 col-xl-3 align-self-center mb-4">
              <div class="dropdown-curve-container mr-2">
                <label
                  :class="
                    selectedCinema && selectedCinema.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
                >
                <b-dropdown
                  :disabled="isRoleID"
                  :text="selectedCinema"
                  name="selectcinema"
                  id="selectcinema"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      :placeholder="$t('searchCinema')"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCinema($event.target.value)"
                      v-on:keydown="onSearchCinema($event.target.value)"
                      v-on:search="onSearchCinema($event.target.value)"
                      v-model="searchCinema"
                    />
                  </div>
                  <b-dropdown-item
                    href="#"
                    v-for="(Cinema, CinemaIndex) in Cinemas"
                    :key="CinemaIndex"
                    v-on:click="onSelectCinema($event, Cinema)"
                    >{{ Cinema.cine_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>

            <!-- Transaction Date From-->
            <div class="col-lg-4 col-xl-3 align-self-center mb-4">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    v-if="fetchTransactionDetail.transaction_date"
                    v-on:click="clearDate(2)"
                    class="btn-clearDate"
                  >
                    ✖
                  </button>
                  <Datepicker
                    :monday-first="true"
                    :disabled="disableShowDate"
                    ref="programaticOpen"
                    v-model="fetchTransactionDetail.transaction_date"
                    name="selectenddate_1"
                    id="selectenddate_1"
                    v-validate="'required'"
                    :typeable="true"
                    @input="onchangeDate($event, 'from')"
                  ></Datepicker>
                  <label
                    :class="
                      fetchTransactionDetail.transaction_date ? 'active' : ''
                    "
                    >{{ $t("transaction") }} {{ $t("fromdate") }}</label
                  >
                </div>
              </div>
            </div>

            <!-- Transaction Date To -->
            <div class="col-lg-4 col-xl-3 align-self-center mb-4">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    v-if="fetchTransactionDetail.transaction_date_to"
                    v-on:click="clearDate('transaction_date_to')"
                    class="btn-clearDate"
                  >
                    ✖
                  </button>
                  <Datepicker
                    :monday-first="true"
                    :disabled="disableShowDate"
                    ref="programaticOpen"
                    v-model="fetchTransactionDetail.transaction_date_to"
                    name="selectenddate_3"
                    id="selectenddate_3"
                    v-validate="'required'"
                    :typeable="true"
                    @input="onchangeDate()"
                    :disabledDates="{
                      from: new Date(
                        moment(fetchTransactionDetail.transaction_date)
                          .add(31, 'd')
                          .format('YYYY-MM-DD')
                      ),
                    }"
                  ></Datepicker>
                  <label
                    :class="
                      fetchTransactionDetail.transaction_date_to ? 'active' : ''
                    "
                    >{{ $t("transaction") }} {{ $t("todate") }}</label
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-xl-3 align-self-center mb-4" v-if="false">
              <!-- <FilterByStatusDropdown /> -->
              <b-dropdown id="listview" variant="outline-blue">
                <template v-slot:button-content>
                  {{ showSelectedTable }}
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in tableFilterOptions"
                  :key="listIndex"
                  @click="changeTableFilter(list.name)"
                  href="#"
                  >{{ list.name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <div style="width: 100%"></div>
            <!-- Show Date From-->
            <div class="col-lg-4 col-xl-3 align-self-center mb-4">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    v-if="fetchTransactionDetail.show_date"
                    v-on:click="clearDate(1)"
                    class="btn-clearDate"
                  >
                    ✖
                  </button>
                  <Datepicker
                    :monday-first="true"
                    :disabled="disableShowDate"
                    ref="programaticOpen"
                    v-model="fetchTransactionDetail.show_date"
                    name="selectenddate_2"
                    id="selectenddate_2"
                    v-validate="'required'"
                    :typeable="true"
                    @input="onChangeShowDate($event, 'from')"
                  ></Datepicker>
                  <label
                    :class="fetchTransactionDetail.show_date ? 'active' : ''"
                    >{{ $t("show") }} {{ $t("fromdate") }}</label
                  >
                </div>
              </div>
            </div>

            <!-- Show Date To-->
            <div class="col-lg-4 col-xl-3 align-self-center mb-4">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    v-if="fetchTransactionDetail.show_date_to"
                    v-on:click="clearDate('show_date_to')"
                    class="btn-clearDate"
                  >
                    ✖
                  </button>
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    :disabled="disableShowDate"
                    v-model="fetchTransactionDetail.show_date_to"
                    name="selectenddate_4"
                    id="selectenddate_4"
                    v-validate="'required'"
                    :typeable="true"
                    @input="onChangeShowDate()"
                    :disabledDates="{
                      from: new Date(
                        moment(fetchTransactionDetail.show_date)
                          .add(31, 'd')
                          .format('YYYY-MM-DD')
                      ),
                    }"
                  ></Datepicker>
                  <label
                    :class="fetchTransactionDetail.show_date_to ? 'active' : ''"
                    >{{ $t("show") }} {{ $t("todate") }}
                  </label>
                </div>
              </div>
            </div>

            <!-- Select Filter -->
            <div class="col-lg-4 col-xl-3 align-self-center mb-4">
              <div class="dropdown-curve-container mr-2">
                <!-- <button v-if="selectedFilter" v-on:click="clearFilter()" class="btn-clearDate">✖</button> -->
                <label
                  :class="
                    selectedFilter && selectedFilter.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $t("select") }} {{ $tc("filter") }}</label
                >
                <b-dropdown
                  :text="selectedFilter"
                  name="selectuser"
                  id="selectcinema"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    href="#"
                    v-for="(User, UserIndex) in users"
                    :key="UserIndex"
                    v-on:click="onSelectFilter($event, User)"
                    >{{ User }}</b-dropdown-item
                  >
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button
                    v-on:click="onSelectFilter($event, 'clearFilter')"
                  >
                    <strong>{{ $t("clear") }} {{ $tc("filter") }}</strong>
                  </b-dropdown-item-button>
                </b-dropdown>
              </div>
            </div>

            <div
              v-if="
                selectedFilter &&
                  selectedFilter.length > 0 &&
                  selectedFilter != 'Show Booking Code' &&
                  selectedFilter != 'User'
              "
              class="col-lg-4 col-xl-3 align-self-center mb-4"
            >
              <div class="dropdown-curve-container menu-item-truncate mr-2">
                <label
                  :class="
                    selectedFilterValue && selectedFilterValue.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $t("select") }} {{ selectedFilter }}</label
                >
                <b-dropdown
                  :text="selectedFilterValue"
                  name="selectuser"
                  id="selectcinema"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Filters"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchFilterValues()"
                      v-on:keydown="onSearchFilterValues()"
                      v-on:search="onSearchFilterValues()"
                      v-model="searchFilterValues"
                    />
                  </div>
                  <b-dropdown-item
                    href="#"
                    v-for="(value, valueIndex) in filterValues"
                    :key="valueIndex"
                    v-on:click="onSelectFilterValue(value)"
                    >{{
                      value.username
                        ? value.username
                        : value.movie
                        ? value.movie
                        : value.screen_name
                    }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
            <div
              v-if="selectedFilter == 'Show Booking Code'"
              class="col-lg-4 col-xl-3 align-self-center mb-4"
            >
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    v-model="filtervalue"
                    name="firstname"
                    id="firstname"
                  />
                  <label>{{ $tc("showBookingCode") }}</label>
                </div>
              </div>
            </div>
            <div
              v-if="selectedFilter == 'User'"
              class="col-lg-4 col-xl-3 align-self-center mb-4"
            >
              <multiselect
                v-model="searchUserValue"
                label="username"
                track-by="user_id"
                :placeholder="$tc('typeToSearchUser')"
                open-direction="bottom"
                :options="searchUsers"
                :multiple="false"
                :options-limit="50"
                :max-height="600"
                :loading="isSearchLoading"
                @select="onSelectFilterValue($event)"
                @search-change="onAsyncSearchUser"
              >
                <span slot="noResult">Oops! No Results found.</span>
              </multiselect>
            </div>

            <div
              v-if="fetchTransactionDetail.show_date"
              class="col-lg-4 col-xl-3 align-self-center mb-4"
            >
              <div class="dropdown-curve-container mr-2 menu-item-truncate">
                <label :class="selected_show_time ? 'shift-up' : ''"
                  >{{ $t("select") }} {{ $t("Showtime") }}</label
                >
                <b-dropdown
                  :text="getShowtimeString(selected_show_time)"
                  name="selectuser"
                  id="selectcinema"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <!-- <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Filters"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchFilterValues()"
                    v-on:keydown="onSearchFilterValues()"
                    v-model="searchFilterValues"
                  />
                </div> -->
                  <b-dropdown-item
                    href="#"
                    v-for="(value, valueIndex) in schedules"
                    :key="valueIndex"
                    v-on:click="onSelectShowtime(value)"
                    >{{
                      moment(value.ss_actual_start_date_time).format(
                        "DD-MM-YYYY"
                      )
                    }}
                    {{ value.ss_start_show_time }} ({{
                      value.movie
                    }})</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>

            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <button
                :disabled="btenable"
                @click.prevent.stop="onGetTransactionList"
                class="btn-blue-lg w-100"
              >
                {{ $tc("fetch") }} {{ $tc("report") }}
              </button>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center my-3">
          <div class="d-flex"></div>
          <div
            class="d-flex align-items-center justify-content-between col-6 pl-0"
            v-if="
              showSelectedTable == 'Transactions' || showSelectedTable == 'Both'
            "
          >
            <div class="input-material">
              <b-form-input
                v-debounce:500="onSearch"
                v-model="searchValue"
                placeholder="Search Email/ Mobile No/ Booking Code"
                style="border-radius: 10px; width: 325px; font-size: 14px"
              />
              <label :class="searchValue ? 'active' : ''">{{
                "Search Email/ Mobile No/ Booking Code"
              }}</label>
            </div>
          </div>
          <div
            class="col-6 justify-content-end d-flex align-items-center"
            v-if="
              showSelectedTable == 'Transactions' || showSelectedTable == 'Both'
            "
          >
            <!-- <FilterByStatusDropdown /> -->
            <div class="mx-2">
              <b-dropdown
                name="listview"
                id="listview"
                variant="outline-blue"
                class=""
              >
                <template v-slot:button-content>
                  <!-- {{ $tc("viewing") }}&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;Of&nbsp; -->
                  <strong>{{ viewingRange }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                  >{{ list.name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <div
              v-if="
                (transactionList.length > 0 &&
                  showSelectedTable == 'Transactions') ||
                  showSelectedTable == 'Both'
              "
              class="d-flex justify-content-end align-items-center"
            >
              <div>{{ $t("download") }} as:</div>
              <a
                target="_blank"
                @click="onGetTransactionList('isPdfData')"
                title="Download as PDF"
                download
              >
                <img
                  class="mx-1"
                  src="@/assets/img/icons/pdf-icon.svg"
                  height="25"
                  width="25"
                />
              </a>
              <a
                target="_blank"
                @click="onGetTransactionList('isExcelData')"
                title="Download as Excel"
                download
              >
                <img
                  src="@/assets/img/icons/excel.svg"
                  height="25"
                  width="25"
                />
              </a>
            </div>
          </div>
        </div>
        <div>
          <!-- <div class="d-flex justify-content-end align-items-center">

        </div> -->

          <div class="swc-report">
            <table
              class="swc-report-table mb-3"
              border="1"
              v-if="
                showSelectedTable == 'Transactions' ||
                  showSelectedTable == 'Both'
              "
            >
              <thead class="bg-lightgrey">
                <tr>
                  <th>{{ $tc("Cinema Name") }}</th>
                  <th class="sticky-cell">{{ $tc("bookingUser") }}</th>
                  <th>{{ $tc("Channel") }}</th>
                  <th>{{ $tc("name") }}</th>
                  <th>{{ $tc("phone") }}</th>
                  <th>{{ $tc("email") }}</th>
                  <th>{{ "Is Guest User" }}</th>

                  <th>
                    {{ $tc("booking") }} {{ $tc("Date") }} & {{ $tc("time") }}
                  </th>
                  <th>
                    {{ $tc("show") }} {{ $tc("date") }} & {{ $tc("time") }}
                  </th>
                  <th>{{ $tc("Booking Code") }}</th>
                  <th>{{ $tc("screen") }}</th>
                  <th>{{ $tc("films") }}</th>

                  <th>{{ $tc("seat") }}</th>

                  <th>{{ $tc("amounts") }}</th>

                  <th>{{ $tc("offer") }} | {{ $tc("voucher") }}</th>
                  <th>{{ $t("comment") }}</th>
                  <th>{{ $t("F&B Items") }}</th>
                  <th>{{ $t("F&B Total Amount") }}</th>
                  <th>{{ $t("MISC Items | MISC Amount") }}</th>
                  <th>{{ $t("MISC Total Amount") }}</th>
                  <th>{{ $t("Final Amount") }}</th>
                  <th>{{ $t("Discount") }}</th>
                  <th>{{ $t("Refunded Amount") }}</th>
                  <th>{{ $t("Total Amount") }}</th>
                  <th>{{ $t("Payment Mode") }}</th>
                  <th>{{ $t("Card Number") }}</th>
                  <th>{{ $t("Refrence Number") }}</th>
                  <th>{{ $t("Remarks") }}</th>
                  <th>{{ $t("Status") }}</th>
                  <th>{{ $t("entered") }}</th>
                  <th v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'">
                    {{ $t("autoentered") }}
                  </th>
                  <th>{{ $tc("refund") }}</th>
                  <th>{{ $tc("print") }}</th>
                  <th>{{ $tc("Send Mail") }}</th>
                  <th>{{ $tc("Send Sms") }}</th>
                </tr>
              </thead>
              <tbody
                v-for="(user, userIndex) in transactionList"
                :key="userIndex"
              >
                <tr>
                  <td>{{ user.cinema_name }}</td>
                  <td class="sticky-cell text-left">
                    {{
                      user.booking_user_name ||
                        user.customer_name ||
                        user.guest_name ||
                        "-"
                    }}
                  </td>
                  <td class="text-left">{{ user.bs_source }}</td>
                  <td class="text-left">
                    {{ user.customer_name || user.guest_name || "-" }}
                  </td>
                  <td class="text-right">
                    {{ user.customer_mobile || user.guest_mobile || "-" }}
                  </td>
                  <td class="text-left">
                    {{ user.cust_email || user.guest_email || "-" }}
                  </td>
                  <td class="text-left">{{ user.guest_name ? "Y" : "N" }}</td>
                  <td class="text-left">
                    {{ user.t_booking_date_time | fulldatemonparse }}
                  </td>
                  <td class="text-left">
                    {{ user.ss_start_date | dateparse }}
                    {{ user.ss_start_show_time }}
                  </td>
                  <td class="text-left">{{ user.sb_booking_code }}</td>
                  <td class="text-left">{{ user.screen_name }}</td>
                  <td class="text-left p-1">{{ user.film_name }}</td>

                  <td class="text-left">{{ user.seats }}</td>

                  <td class="text-right">
                    {{ user.total_amount.toFixed(MIN_FRACTION_DIGITS) }}
                  </td>
                  <td>
                    {{
                      user.offer_name
                        ? user.offer_name
                        : user.voucher_name
                        ? user.voucher_name
                        : "-"
                    }}
                  </td>
                  <td class="text-left">{{ user.comment || "-" }}</td>
                  <td class="text-left">{{ user.fnb_items || "-" }}</td>
                  <td class="text-right">
                    {{
                      user.fnb_total_amount
                        ? parseFloat(user.fnb_total_amount).toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        : "0.00"
                    }}
                  </td>
                  <td>
                    <div v-if="user.miscellanous_array.length == 0">-</div>
                    <div
                      class="d-flex justify-content-between"
                      v-for="(misc, misc_index) in user.miscellanous_array"
                      v-if="user.miscellanous_array.length > 0"
                      :key="misc_index"
                    >
                      <b class="px-1">{{ misc.key_name }} :</b>
                      <b class="px-1">{{ misc.key_charge }}</b>
                    </div>
                  </td>
                  <td class="text-right">
                    {{
                      user.miscellanous_amount
                        ? parseFloat(user.miscellanous_amount).toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        : "0.00"
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      user.final_total_amount
                        ? parseFloat(user.final_total_amount).toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        : "0.00"
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      user.discount
                        ? parseFloat(user.discount).toFixed(MIN_FRACTION_DIGITS)
                        : "0.00"
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      user.t_refunded_amount
                        ? parseFloat(
                            +parseFloat(user.t_refunded_amount) +
                              parseFloat(user.fnb_refund || 0)
                          ).toFixed(MIN_FRACTION_DIGITS)
                        : "0.00"
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      user.total_final_amount
                        ? parseFloat(user.total_final_amount).toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        : "0.00"
                    }}
                  </td>
                  <td class="text-left">
                    {{ user.pm_payment_mode ? user.pm_payment_mode : "-" }}
                  </td>
                  <!-- <td class="text-right">
                    {{ user.payment_transaction_detail ? user.payment_transaction_detail.response.merchant_param6 :"-" }}
                  </td> -->
                  <td class="text-right">
                    <template v-if="isStarClient">
                      {{
                        user.payment_transaction_detail &&
                        user.hasOwnProperty("payment_transaction_detail") &&
                        user.payment_transaction_detail.hasOwnProperty(
                          "response"
                        ) &&
                        user["payment_transaction_detail"]["response"] &&
                        user.payment_transaction_detail["response"][
                          "merchant_param6"
                        ]
                          ? user["payment_transaction_detail"]["response"][
                              "merchant_param6"
                            ] || "-"
                          : "-"
                      }}
                    </template>
                    <template v-else-if="isEmpireClient">
                      {{
                        user.payment_transaction_detail
                          ? user.payment_transaction_detail.card
                          : "-"
                      }}
                    </template>
                    <template v-else> - </template>
                  </td>

                  <!-- <td class="text-right">
                    {{
                      user.payment_transaction_detail
                        ? user.payment_transaction_detail.verified.reference_no
                        : "-"
                    }}
                  </td> -->

                  <td class="text-right">
                    <template v-if="isStarClient">
                      {{
                        user.payment_transaction_detail &&
                        user.hasOwnProperty("payment_transaction_detail") &&
                        user.payment_transaction_detail.hasOwnProperty(
                          "verified"
                        ) &&
                        user["payment_transaction_detail"]["reference_no"] &&
                        user.payment_transaction_detail["verified"][
                          "reference_no"
                        ]
                          ? user["payment_transaction_detail"]["verified"][
                              "reference_no"
                            ] || "-"
                          : "-"
                      }}
                    </template>
                    <template v-else-if="isEmpireClient">
                      {{
                        user.payment_transaction_detail
                          ? user.payment_transaction_detail.ref
                          : "-"
                      }}
                    </template>
                    <template v-else> - </template>
                  </td>
                  <td class="text-right">
                    {{ user.bo_trx_remarks ? user.bo_trx_remarks : "-" }}
                  </td>
                  <td class="text-left">
                    <div
                      v-if="
                        parseFloat(user.final_total_amount) -
                          parseFloat(user.discount) ==
                          parseFloat(user.t_refunded_amount || 0) +
                            parseFloat(user.fnb_refund || 0) &&
                          parseFloat(user.t_refunded_amount || 0) +
                            parseFloat(user.fnb_refund || 0) >
                            0
                      "
                    >
                      {{ $tc("Full Refund") }}
                    </div>
                    <div
                      v-else-if="
                        parseFloat(user.t_refunded_amount || 0) +
                          parseFloat(user.fnb_refund || 0) >
                          0 && user.final_total_amount != 0
                      "
                    >
                      {{ $tc("Partial Refund") }}
                    </div>
                    <div v-else-if="user.booking_status_id == 3">
                      {{ $tc("Active") }}
                    </div>
                  </td>
                  <td>
                    <span v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'">{{
                      parseInt(user.totalEntered || 0) -
                        parseInt(user.auto_entered || 0)
                    }}</span>
                    <span v-else>{{ parseInt(user.totalEntered || 0) }}</span>
                  </td>
                  <td v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'">
                    {{ user.auto_entered || 0 }}
                  </td>
                  <td class="text-left">
                    <b-button
                      v-if="user.booking_status_id == 3"
                      variant="default"
                      :to="
                        `/cinema-manager/make-a-refund?booking_id=${user.sb_booking_code}`
                      "
                      class="btn-blue v-step-1"
                      >{{ $tc("refund") }}</b-button
                    >
                    <div v-else-if="user.booking_status_id == 12">
                      <span
                        >{{ $t("refund_done")
                        }}{{ user.booking_status_id }}</span
                      >
                    </div>
                  </td>
                  <td>
                    <b-button
                      v-if="!checkClientEmpire"
                      @click="
                        onPrintHandler(
                          user.sb_id,
                          user.cinema_id,
                          user.ft_id,
                          user.t_id,
                          user.booking_status_id == 12
                        )
                      "
                      class="btn-blue v-step-1 test"
                      >{{ $t("print") }}</b-button
                    >
                    <div v-else>
                      <div>
                        <button
                          class="btn-transparent text-blue"
                          @click="
                            onPrintHandler(
                              user.sb_id,
                              user.cinema_id,
                              user.ft_id,
                              user.t_id
                            )
                          "
                        >
                          <u>View Box Office Ticket</u>
                        </button>
                      </div>
                      <div v-if="user.ft_id">
                        <button
                          class="btn-transparent text-blue"
                          @click="
                            FNBPRINT(
                              user.ft_id,
                              user.order_code,
                              user.ft_uer_id
                            )
                          "
                        >
                          <u>View Fnb Ticket</u>
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <b-button
                      :disabled="
                        user.cust_email || user.guest_email ? false : true
                      "
                      variant="default"
                      @click="sendMailToUser(user)"
                      class="btn-blue v-step-1"
                      >{{ $t("Send Mail") }}</b-button
                    >
                  </td>
                  <td>
                    <b-button
                      :disabled="
                        user.customer_mobile || user.guest_mobile ? false : true
                      "
                      variant="default"
                      @click="sendSMSToUser(user)"
                      class="btn-blue v-step-1"
                      >{{ $t("Send SMS") }}</b-button
                    >
                  </td>
                </tr>
              </tbody>
              <tbody v-if="transactionList.length == 0">
                <tr>
                  <td colspan="13">
                    <!-- <p v-if="transactionList.length == 0" class="text-center">
                    {{ $tc("NoRecords") }}
                  </p> -->
                    <NoRecords />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <b-pagination
          v-if="
            (transactionList.length > 0 &&
              showSelectedTable == 'Transactions') ||
              showSelectedTable == 'Both'
          "
          v-model="currentPage"
          :total-rows="rows"
          @change="onChangePagination($event)"
          :per-page="perPage"
          aria-controls="my-table"
          class="my-3"
        ></b-pagination>
      </div>

      <b-modal id="sendSMS" ref="sendSMS" title="Send SMS" hide-footer show>
        <div v-if="sendSMSObj.length > 0">
          <div class="row mx-0">
            <div class="col-4">Customer Name :</div>
            <div class="col-8">
              <div class="input-material">
                <strong>{{
                  sendSMSObj[0].customer_name || sendSMSObj[0].guest_name || "-"
                }}</strong>
              </div>
            </div>
          </div>

          <div class="row mx-0">
            <div class="col-4">Booking Code :</div>
            <div class="col-8">
              <div class="input-material">
                <strong>{{ sendSMSObj[0].sb_booking_code }}</strong>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="col-4">Phone Number</div>
            <div class="col-8">
              <div class="input-material">
                <input
                  type="email"
                  v-model="sendSMSObj[0].phone_number"
                  :disabled="true"
                />
              </div>
            </div>
          </div>

          <div class="row my-2 mx-0">
            <div class="col-4">Is Alternate Phone:</div>
            <div class="col-8">
              <div class="input-material">
                <b-form-checkbox
                  v-model="sendSMSObj[0].is_alternative_phone"
                  @change="alternateChangeSMS($event)"
                  unchecked-value="N"
                  value="Y"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div>

          <div
            class="row my-2 mx-0"
            v-if="sendSMSObj[0].is_alternative_phone == 'Y'"
          >
            <div class="col-4">Alternate Phone No :</div>
            <div class="col-2 p-0">
              <div class="input-material">
                <input
                  type="email"
                  v-model="sendSMSObj[0].country_code_mob"
                  :disabled="true"
                />
              </div>
            </div>
            <div class="col-6 p-0">
              <div class="input-material">
                <input
                  type="number"
                  v-model="sendSMSObj[0].alternative_phone"
                />
              </div>
            </div>
          </div>

          <div class="col-12 pt-3 text-center">
            <button v-on:click="sendSmstoUpdate()" class="btn-blue">
              Send
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal id="sendMail" ref="sendMail" title="Send Mail" hide-footer show>
        <div v-if="sendMailObj.length > 0">
          <div class="row mx-0">
            <div class="col-4">Customer Name :</div>
            <div class="col-8">
              <div class="input-material">
                <strong>{{
                  sendMailObj[0].customer_name ||
                    sendMailObj[0].guest_name ||
                    "-"
                }}</strong>
              </div>
            </div>
          </div>

          <div class="row mx-0">
            <div class="col-4">Booking Code :</div>
            <div class="col-8">
              <div class="input-material">
                <strong>{{ sendMailObj[0].sb_booking_code }}</strong>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="col-4">Email Id :</div>
            <div class="col-8">
              <div class="input-material">
                <input
                  type="email"
                  v-model="sendMailObj[0].email_id"
                  :disabled="sendMailObj[0].guest_id ? false : true"
                />
              </div>
            </div>
          </div>

          <div class="row my-2 mx-0">
            <div class="col-4">Is Alternate Email:</div>
            <div class="col-8">
              <div class="input-material">
                <b-form-checkbox
                  v-model="sendMailObj[0].is_alternative_email"
                  @change="alternateChangeEMail($event)"
                  unchecked-value="N"
                  value="Y"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div>

          <div
            class="row my-2 mx-0"
            v-if="sendMailObj[0].is_alternative_email == 'Y'"
          >
            <div class="col-4">Alternate Email :</div>
            <div class="col-8">
              <div class="input-material">
                <input
                  type="email"
                  v-model="sendMailObj[0].alternative_email_address"
                />
              </div>
            </div>
          </div>

          <div class="col-12 pt-3 text-center">
            <button v-on:click="sendMailToUpdate()" class="btn-blue">
              Send
            </button>
          </div>
        </div>
      </b-modal>
    </div>
    <div class="animated revealUp">
      <!-- FNB Transactions Report Table -->

      <div
        class="white-wrapper mt-3"
        v-if="
          showSelectedTable == 'F&B Transactions' || showSelectedTable == 'Both'
        "
      >
        <div class="section-title mb-4">{{ $t("F&B Transactions") }}</div>
        <div
          class="mb-2 d-flex justify-content-between"
          v-if="
            showSelectedTable == 'F&B Transactions' ||
              showSelectedTable == 'Both'
          "
        >
          <div class="input-material">
            <b-form-input
              v-debounce:500="onSearch"
              v-model="fnbsearchValue"
              placeholder="Search Booking Code"
              style="border-radius: 10px; width: 295px; font-size: 14px"
            />
            <label :class="fnbsearchValue ? 'active' : ''">{{
              "Search"
            }}</label>
          </div>

          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $tc("viewing") }}&nbsp;
              <strong>{{ fnbselectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ fnbRows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in fnbviewingnumbers"
              :key="listIndex"
              @click="fnbonDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>

          <div
            v-if="
              (fnbtransactionList.length > 0 &&
                showSelectedTable == 'F&B Transactions') ||
                showSelectedTable == 'Both'
            "
            class="d-flex justify-content-end align-items-center"
            style="width: 20%"
          >
            <div>{{ $t("download") }} as:</div>
            <a
              href="#"
              @click="excelDownloadFnB(BASE_URL, 'pdf')"
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              href="#"
              @click="excelDownloadFnB(BASE_URL, 'excel')"
              title="Download as Excel"
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>
        </div>
        <div class="swc-report mt-2 mb-2">
          <table
            class="swc-report-table mb-2"
            border="1"
            v-if="
              showSelectedTable == 'F&B Transactions' ||
                showSelectedTable == 'Both'
            "
          >
            <thead>
              <tr>
                <th>Cinema Name</th>
                <th>{{ $tc("order") }} {{ $tc("code") }}</th>
                <th>
                  {{ $tc("item") }} {{ $tc("name") }} ({{ $tc("quantity") }})
                </th>
                <th>{{ $tc("Ticket") }} {{ $tc("Code") }}</th>
                <th>{{ $tc("revenue") }}</th>
                <th>{{ $tc("bookingsource") }}</th>
                <th>
                  {{ $tc("transaction") }} {{ $tc("date") }} &
                  {{ $tc("time") }}
                </th>

                <th>{{ $tc("payment") }} {{ $tc("mode") }}</th>
                <th>{{ $tc("offer") }}</th>
                <th>Customer Name</th>
                <th>Customer Email</th>
                <th>Customer Mobile No.</th>
                <th>{{ $tc("view") }} {{ $tc("details") }}</th>
              </tr>
            </thead>
            <tbody
              v-if="fnbtransactionList.length > 0"
              v-for="(fnbtrans, fnbtransIndex) in fnbtransactionList"
              :key="fnbtransIndex"
              class="sph-report"
            >
              <tr>
                <td class="text-right">
                  {{ fnbtrans.ft_cinema_name ? fnbtrans.ft_cinema_name : "-" }}
                </td>
                <td class="text-right">{{ fnbtrans.order_code }}</td>
                <td class="text-left">{{ fnbtrans.item_with_quantity }}</td>
                <td class="text-left">{{ fnbtrans.sb_booking_code }}</td>
                <td class="text-left">
                  {{ fnbtrans.ft_currency_name }}
                  {{ fnbtrans.ft_total_amount.toFixed(MIN_FRACTION_DIGITS) }}
                </td>
                <td class="text-left">{{ fnbtrans.bs_source }}</td>
                <td class="text-left">
                  {{ fnbtrans.ft_date_time | fulldatemonparse }}
                </td>
                <td class="text-left">{{ fnbtrans.fst_payment_mode }}</td>

                <td class="text-left">
                  {{ fnbtrans.ft_offer_name ? fnbtrans.ft_offer_name : "-" }}
                </td>
                <td class="text-left">
                  {{
                    fnbtrans.customer_name ||
                      fnbtrans.guest_name ||
                      fnbtrans.customer_name_pos ||
                      "-"
                  }}
                </td>
                <td class="text-left">
                  {{
                    fnbtrans.cust_email ||
                      fnbtrans.guest_email ||
                      fnbtrans.cust_pos_email ||
                      "-"
                  }}
                </td>
                <td class="text-left">
                  {{
                    fnbtrans.customer_mobile ||
                      fnbtrans.guest_mobile ||
                      fnbtrans.customer_mobile_pos ||
                      "-"
                  }}
                </td>
                <td style="text-align: center">
                  <button
                    class="btn-transparent text-blue"
                    @click="toDetails(fnbtrans)"
                  >
                    View More
                  </button>
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td v-if="fnbtransactionList.length == 0" colspan="9">
                  <!-- <p class="text-center">{{ $tc("NoRecords") }}</p> -->
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <b-pagination
          v-if="
            showSelectedTable == 'F&B Transactions' ||
              showSelectedTable == 'Both'
          "
          v-model="fnbcurrentPage"
          :total-rows="fnbRows"
          @change="fnbonChangePagination($event)"
          :per-page="fnbperPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
    <ManagerAuthLogin
      :moduleName="'transaction_print'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_transaction_print'"
      :additionalRoleIds="isEmpireClient ? roleIds : ''"
    />
  </div>
</template>
<script>
  import CinemasService from "@/services/CinemasService";
  import UserService from "@/services/UserService";
  import MovieService from "@/services/MovieService";
  import MasterService from "@/services/MasterService";
  import SetupService from "@/services/SetupService";
  import moment from "moment-timezone";
  import DatePicker from "vue2-datepicker";
  import Multiselect from "vue-multiselect";
  import _ from "lodash";
  import scheduleService from "@/services/scheduleService";
  import PosService from "@/services/PosService";
  import Printd from "printd";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import { createQueryString } from "@/services/ApiHelper";
  import PosFnbService from "@/services/PosFnbService";
  import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
  import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

  export default {
    components: { DatePicker, Multiselect, NoRecords, ManagerAuthLogin },
    data() {
      return {
        noAuth: false,
        authNextPayload: {
          sb_id: null,
          cinema_id: null,
          ft_id: null,
          order_code: "",
        },
        roleIds: "38",
        searchValue: "",
        CinemasCopy: [],
        searchCinema: "",
        btenable: false,
        selectedFilterValue: "",
        filterValues: [],
        filterValuesCopy: [],
        searchFilterValues: "",
        isRoleID: true,
        transactionList: [],
        transactionListCopy: [],
        searchUserValue: "",
        searchUsers: [],
        isSearchLoading: false,
        schedules: [],
        selected_ssid: "",
        selected_show_time: null,

        selectedFilter: "",
        users: ["Screen", "Movie", "User"],
        fetchTransactionDetail: {
          date: "",
          cinema_id: null,
          ssb_code: "",
          show_date: moment().toDate(),
          show_date_to: "",
          transaction_date: "",
          transaction_date_to: "",
        },
        filterkey: "",
        filtervalue: "",
        selectedCinema: "",
        Cinemas: [],
        EjsData: null,
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",
        viewingnumbers: [],
        sendMailObj: [],
        sendSMSObj: [],
        currencyData: "",

        bs_id: null,
        fnbtransactionList: [],
        fnbperPage: 10,
        fnbcurrentPage: 1,
        fnbRows: 0,
        fnbselectedvalue: "10",
        fnbviewingnumbers: [],
        fnbsearchValue: "",
        tableFilterOptions: [
          { name: "Transactions", index: "1" },
          { name: "F&B Transactions", index: "2" },
          { name: "Both", index: "3" },
        ],
        showSelectedTable: "Transactions",
        setStatus: "-",
      };
    },
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      this.getCurrencyCode();
      if (true) {
        this.isRoleID = false;
        this.getCinemaList(obj);
        console.log({ obj });
      }

      let CinemaObj = null;
      if (CinemaObj) {
        console.log({ CinemaObj });
        this.onSelectCinema(null, CinemaObj);
      }

      let queryparams = this.$route.query;
      if (queryparams.cinema_id && parseInt(queryparams.cinema_id)) {
        this.fetchTransactionDetail.cinema_id = parseInt(queryparams.cinema_id)
          ? parseInt(queryparams.cinema_id)
          : "";
      }

      if (queryparams.date) {
        this.fetchTransactionDetail.show_date = queryparams.date;
      }

      if (queryparams.md_id && parseInt(queryparams.md_id)) {
        this.selectedFilter = "Movie";
        this.filterkey = "md_id";
        this.filtervalue = parseInt(queryparams.md_id);
        this.getMoviesList();
      }

      if (queryparams.ss_id && parseInt(queryparams.ss_id)) {
        this.selected_ssid = queryparams.ss_id;
        this.getSchedule();
      }

      // this.onGetTransactionList();
      this.getviewingnumber();
      this.getFnbviewingnumber();
    },
    watch: {
      "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
        if (CinemaObj) {
          this.onSelectCinema(null, CinemaObj);
        }
      },
    },
    computed: {
      checkClientEmpire() {
        return this.authorizeClient(
          CLIENT_NAMES_OBJ.transaction_report_tickets
        );
      },
      isEmpireClient() {
        return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
      },
      isStarClient() {
        return CLIENT_NAME.STAR == this.CLIENT_SETUP_NAME;
      },
      MANAGER_AUTH_FOR_REPRINT() {
        return this.$store.getters.MANAGER_AUTH_FOR_REPRINT;
      },
      AUTO_ADMIT_TICKET_AFTER_SHOW() {
        return this.$store.getters.AUTO_ADMIT_TICKET_AFTER_SHOW;
      },
      disableShowDate() {
        let self = this;
        console.log("disableShowDate", self.filterkey);
        if (this.filterkey == "sb_booking_code") {
          return true;
        } else {
          return false;
        }
      },
      checkValidation() {
        console.log("checkValidation", this.filterkey);
        if (this.filterkey == "sb_booking_code") {
          return true;
        } else if (this.fetchTransactionDetail.show_date) {
          return true;
        } else if (this.fetchTransactionDetail.transaction_date) {
          return true;
        } else if (this.searchValue) {
          return true;
        } else if (
          this.selectedFilter === "Movie" &&
          this.filterkey === "md_id" &&
          this.filtervalue
        ) {
          return true;
        } else if (this.selected_ssid) {
          return true;
        } else {
          if (
            (!this.fetchTransactionDetail.show_date &&
              !this.fetchTransactionDetail.transaction_date) ||
            !this.$router.query.show_date
          ) {
            this.$toasted.show("Please Select Dates");
          }
          return false;
        }
      },
      viewingRange() {
        if (this.rows === 0) {
          return "Viewing 0 to 0 of 0";
        }

        const start = (this.currentPage - 1) * this.perPage + 1;
        const end = Math.min(this.currentPage * this.perPage, this.rows);

        return `Viewing ${start} to ${end} of ${this.rows}`;
      },
    },
    methods: {
      // onChangeDate(e, type) {
      //   console.log("onChangeDate", type);
      //   if (type == "from") {
      //     this.toDate = new Date(e);
      //     this.$forceUpdate();
      //   }
      // },
      alternateChangeEMail(e) {
        console.log(e, "onchange");
        this.sendMailObj[0]["is_alternative_email"] = e;
        this.$forceUpdate();
      },
      alternateChangeSMS(e) {
        console.log(e, "onchange");

        this.sendSMSObj[0]["is_alternative_phone"] = e;
        this.$forceUpdate();
      },
      onSearch() {
        this.currentPage = 1;
        // this.onGetTransactionList();
        // this.getFnBTransactionList();
      },
      getCurrencyCode: function() {
        let payload = {
          tableName: "ms_currencies",
          curr_is_active: "Y",
          curr_id:
            this.secureStore.get("BRGLOPCU") &&
            this.secureStore.get("BRGLOPCU").go_value,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.currencyData = data.Records[0];
              console.log(this.currencyData, " this.currencyData");
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      },
      sendSmstoUpdate() {
        let payload = {
          sb_booking_code: this.sendSMSObj[0].sb_booking_code,
          phone_number:
            this.sendSMSObj[0].customer_mobile ||
            this.sendSMSObj[0].guest_mobile,
          currency_code: this.currencyData.curr_code,
        };

        if (this.sendSMSObj[0].guest_id) {
          payload["guest_id"] = this.sendSMSObj[0].guest_id;
        }

        if (this.sendSMSObj[0].is_alternative_phone == "Y") {
          if (!this.sendSMSObj[0].alternative_phone) {
            return this.$toasted.show("Please enter alternate email");
          }

          if (String(this.sendSMSObj[0].alternative_phone).length <= 7) {
            return this.$toasted.show("Please enter valid phone number");
          }
          payload[
            "alternative_phone"
          ] = `${this.sendSMSObj[0].alternative_phone}`;
        }

        let loader = this.$loading.show();

        let checkEmailExist = this.sendSMSObj.filter((z) => {
          return (
            z.customer_mobile == z.phone_number ||
            z.guest_mobile == z.phone_number
          );
        });
        if (checkEmailExist.length == 0) {
          payload["phone_number_new"] = this.sendMailObj[0].phone_number;
        }
        MasterService.SendBookingSMS(payload)
          .then((response) => {
            const { data } = response;
            this.$toasted.show("SMS Sent");
            this.$refs.sendSMS.hide();
            loader.hide();
            this.onGetTransactionList();
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      },
      ValidateEmail(inputText) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(inputText)) {
          return true;
        } else {
          return false;
        }
      },
      sendMailToUpdate() {
        let payload = {
          sb_booking_code: this.sendMailObj[0].sb_booking_code,
          email:
            this.sendMailObj[0].cust_email || this.sendMailObj[0].guest_email,
          currency_code: this.currencyData.curr_code,
        };

        if (this.sendMailObj[0].guest_id) {
          payload["guest_id"] = this.sendMailObj[0].guest_id;
        }
        let checkEmailExist = this.sendMailObj.filter((z) => {
          return z.cust_email == z.email_id || z.guest_email == z.email_id;
        });
        if (checkEmailExist.length == 0) {
          payload["email_id_new"] = this.sendMailObj[0].email_id;
        }

        if (this.sendMailObj[0].is_alternative_email == "Y") {
          if (!this.sendMailObj[0].alternative_email_address) {
            return this.$toasted.show("Please enter alternate email");
          }

          if (
            !this.ValidateEmail(this.sendMailObj[0].alternative_email_address)
          ) {
            return this.$toasted.show("Please enter valid email");
          }
          payload[
            "alternate_email"
          ] = this.sendMailObj[0].alternative_email_address;
        }
        let loader = this.$loading.show();

        MasterService.SendBookingMail(payload)
          .then((response) => {
            const { data } = response;
            this.$toasted.show("Mail Sent");
            this.$refs.sendMail.hide();
            loader.hide();
            this.onGetTransactionList();
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      },
      sendMailToUser(obj) {
        this.sendMailObj = [];
        obj["email_id"] = obj.cust_email || obj.guest_email || null;
        if (obj["email_id"]) {
          obj["is_alternative_email"] = "N";
          obj["alternative_email_address"] = "";
          this.sendMailObj.push(obj);
          console.log(this.sendMailObj);
          this.$forceUpdate();
          this.$refs.sendMail.show();
        } else {
          this.$toasted.show(`User Not Attached to Booking`);
        }
      },
      sendSMSToUser(obj) {
        this.sendSMSObj = [];

        obj["phone_number"] = obj.customer_mobile || obj.guest_mobile || null;
        if (obj["phone_number"]) {
          obj["country_code_mob"] =
            `+` + (obj["country_mob_code"] || obj["guest_country_code"]);
          obj["is_alternative_phone"] = "N";
          obj["alternative_phone"] = "";
          this.sendSMSObj.push(obj);

          this.$refs.sendSMS.show();
        } else {
          this.$toasted.show(`User Not Attached to Booking`);
        }
      },
      clearShowDates() {
        this.fetchTransactionDetail.show_date = "";
        this.fetchTransactionDetail.show_date_to = "";
        this.fetchTransactionDetail.transaction_date = "";
        this.fetchTransactionDetail.transaction_date_to = "";
      },
      excelDownload(BASE_URL, type) {
        let payload = {
          cinema_id: this.fetchTransactionDetail.cinema_id,
          transaction_date: this.fetchTransactionDetail.transaction_date
            ? moment(this.fetchTransactionDetail.transaction_date).format(
                "YYYY-MM-DD"
              )
            : null,
          show_date: this.fetchTransactionDetail.show_date
            ? moment(this.fetchTransactionDetail.show_date).format("YYYY-MM-DD")
            : null,
          filterkey: this.filterkey ? this.filterkey : null,
          filtervalue: this.filtervalue ? this.filtervalue : null,
          ss_id: this.selected_ssid || null,
          limit: this.rows,
          currentPage: null,
          searchValue: this.searchValue,
          type: type,
        };
        payload["transaction_date_to"] = this.fetchTransactionDetail
          .transaction_date_to
          ? moment(this.fetchTransactionDetail.transaction_date_to).format(
              "YYYY-MM-DD"
            )
          : null;

        payload["show_date_to"] = this.fetchTransactionDetail.show_date_to
          ? moment(this.fetchTransactionDetail.show_date_to).format(
              "YYYY-MM-DD"
            )
          : null;
        console.log("payloadddd", payload);
        let qs = createQueryString(payload);
        console.log(qs);
        window.open(
          `${BASE_URL}/api/admin/reports/v2/transactions${qs}`,
          "_blank"
        );
      },
      excelDownloadFnB(BASE_URL, type) {
        let payload = {
          from_date: this.fetchTransactionDetail.transaction_date
            ? moment(this.fetchTransactionDetail.transaction_date).format(
                "YYYY-MM-DD"
              )
            : "",
          date: this.fetchTransactionDetail.transaction_date_to
            ? moment(this.fetchTransactionDetail.transaction_date_to).format(
                "YYYY-MM-DD"
              )
            : "",
          searchValue: this.fnbsearchValue ? this.fnbsearchValue : "",
          cinema_id: this.fetchTransactionDetail.cinema_id
            ? this.fetchTransactionDetail.cinema_id
            : "",
          type: type,
        };
        let qs = createQueryString(payload);
        window.open(
          `${BASE_URL}/api/admin/reports/v2/fnbtransactionsexcel${qs}`,
          "_blank"
        );
      },
      moment,
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          console.log("perPage :", this.perPage);
          this.onChangePagination();
        }
      },
      onChangePagination: function(event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          this.onGetTransactionList();
        } else {
          this.currentPage = event;
          this.onGetTransactionList();
        }
      },
      onCheckAuthentication(response) {
        const { valid, name } = response;
        if (valid) {
          if (name == "transaction_print") {
            this.noAuth = true;
            this.$bvModal.hide("authManager_transaction_print");
            if (this.authNextPayload.hasOwnProperty("order_code")) {
              if (this.authNextPayload.order_code) {
                this.FNBPRINT(
                  this.authNextPayload.ft_id,
                  this.authNextPayload.order_code,
                  this.authNextPayload.ft_uer_id
                );
              }
            } else {
              this.onPrintHandler(
                this.authNextPayload.sb_id,
                this.authNextPayload.cinema_id,
                this.authNextPayload.ft_id,
                this.authNextPayload.t_id
              );
            }
          }
        }
      },
      onPrintHandler: async function(
        sb_id,
        cinema_id,
        ft_id = null,
        t_id,
        booking_status_id,
        isBoxOffice = true
      ) {
        this.authNextPayload = {
          sb_id: sb_id,
          cinema_id: cinema_id,
          ft_id: ft_id,
          t_id: t_id,
          booking_status_id,
        };
        // console.log(booking_status_id, "booking_status_id");
        console.log(
          "onPrintHandler this.MANAGER_AUTH_FOR_REPRINT",
          this.MANAGER_AUTH_FOR_REPRINT,
          !this.noAuth
        );
        const isQFXCinema = CLIENT_NAME.QFX === this.CLIENT_SETUP_NAME;
        let templateData = [];
        await MasterService.TicketTemplateByCinemaID({ cine_id: cinema_id })
          .then((resp) => {
            const { data } = resp;
            templateData = data.Records;
          })
          .catch(() => {
            return this.$toasted.show("No ticket template found.");
          });
        console.log("tempalteData", templateData);
        if (this.MANAGER_AUTH_FOR_REPRINT == "Y" && !this.noAuth) {
          this.$bvModal.show("authManager_transaction_print");
        } else {
          let loader = this.$loading.show();
          let isReprint = true;
          let response;
          let transactionIndex = this.transactionList.findIndex(
            (transaction) => transaction.sb_id == sb_id
          );

          // if (
          //   templateData &&
          //   templateData.length > 0 &&
          //   templateData[0].t_name == "Template-12"
          // ) {
          //   response = await PosService.GetEmpireTicketEjs(
          //     t_id,
          //     cinema_id,
          //     true
          //   ).catch(this._CatchError);
          // } else {
          const isPlatinumCinema =
            CLIENT_NAME.PLATINUM == this.CLIENT_SETUP_NAME;
          console.log(ft_id, !this.checkClientEmpire, isBoxOffice);
          console.log(this.CLIENT_SETUP_NAME, "this.CLIENT_SETUP_NAME");
          if (
            !this.checkClientEmpire &&
            isBoxOffice &&
            !CLIENT_NAME.WOW == this.CLIENT_SETUP_NAME &&
            !CLIENT_NAME.PLAYCINEMA == this.CLIENT_SETUP_NAME &&
            !isPlatinumCinema
          ) {
            response = await PosService.GetBoxOffice_FnbTicketEjs(
              sb_id,
              ft_id,
              cinema_id,
              "BoxOfficeFnbTicket",
              isReprint,
              this.transactionList[transactionIndex].t_refunded_amount > 0
                ? "Y"
                : "N"
            ).catch(this._CatchError);
          } else {
            if (
              CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME ||
              CLIENT_NAME.WOW == this.CLIENT_SETUP_NAME
            ) {
              console.log(this.CLIENT_SETUP_NAME, "This if is working fine");
              response = await PosService.getQfxEntrancePass({ sb_id }).catch(
                this._CatchError
              );
              if (response) {
                const { data } = response;

                this.EjsData = data;

                if (this.EjsData) {
                  this.$nextTick(() => {
                    const p = new Printd();
                    p.print(this.$refs.onPrint, []);
                    this.EjsData = "";
                  });
                }
                loader.hide();
              }
            }
            if (
              CLIENT_NAME.WOW == this.CLIENT_SETUP_NAME ||
              CLIENT_NAME.PLAYCINEMA == this.CLIENT_SETUP_NAME ||
              isPlatinumCinema
            ) {
              const isRefund = booking_status_id;

              let onlyBoTicketOrderCode = 0;
              response = await PosService.GetWOWTicketEjs(
                sb_id,
                cinema_id,
                onlyBoTicketOrderCode,
                isReprint,
                isRefund
              ).catch(this._CatchError);
            }
            // if(CLIENT_NAME.PLAYCINEMA == this.CLIENT_SETUP_NAME){

            // }
            else {
              if (isReprint && isQFXCinema) {
                // console.log(sb_id, "sb_id");
                await PosService.CHECK_LIMIT_REPRINT({
                  sb_id: sb_id,
                });
              }
              response = await PosService.GetTicketEjs(
                sb_id,
                cinema_id,
                isReprint
              ).catch(this._CatchError);
            }
          }
          // }

          if (response) {
            const { data } = response;

            this.EjsData = data;

            if (this.EjsData) {
              this.$nextTick(() => {
                const p = new Printd();
                p.print(this.$refs.onPrint, []);
                this.EjsData = "";
              });
            }
            loader.hide();
          }
        }
      },
      async FNBPRINT(ft_id, order_code, ft_uer_id) {
        let isReprint = true;
        const isQFXCinema = CLIENT_NAME.QFX === this.CLIENT_SETUP_NAME;
        console.log("COMING HERE FNBPRINT", ft_id, order_code, ft_uer_id);

        this.authNextPayload = {
          sb_id: null,
          cinema_id: null,
          ft_id: ft_id,
          t_id: null,
          order_code: order_code,
          ft_uer_id: ft_uer_id,
        };
        if (this.MANAGER_AUTH_FOR_REPRINT == "Y" && !this.noAuth) {
          this.$bvModal.show("authManager_transaction_print");
          return;
        }
        let loader = this.$loading.show();

        let response = await PosFnbService.GetFnbOrderEjs({
          OrderCode: order_code,
          Type: "Print",
          UserID: ft_uer_id,
          isReprint,
        }).catch(this._CatchError);
        if (isReprint && isQFXCinema) {
          // console.log(sb_id, "sb_id");
          await PosService.CHECK_LIMIT_REPRINT_FNB({
            orderCode: order_code,
            ft_id: ft_id || null,
          });
        }
        if (response) {
          const { data } = response;

          this.EjsData = data;

          this.$nextTick(() => {
            loader.hide();
            const p = new Printd();
            if (this.$refs.onPrint && this.EjsData != null) {
              p.print(this.$refs.onPrint, []);
              this.EjsData = "";
            }
          });
        }
      },
      clearDate(type = 1) {
        this.currentPage = 1;
        this.transactionList = [];

        switch (type) {
          case 1:
          case "show_date_to":
            this.fetchTransactionDetail.show_date = "";
            this.fetchTransactionDetail.show_date_to = "";
            break;
          case 2:
          case "transaction_date_to":
            this.fetchTransactionDetail.transaction_date = "";
            this.fetchTransactionDetail.transaction_date_to = "";
            break;
        }
      },
      onchangeDate: _.debounce(function(e, type) {
        this.transactionList = [];
        this.fetchTransactionDetail.show_date = "";
        this.fetchTransactionDetail.show_date_to = "";
        this.currentPage = 1;

        if (type == "from") {
          this.fetchTransactionDetail.transaction_date_to = new Date(e);
          this.$forceUpdate();
        }
      }, 500),
      onChangeShowDate: _.debounce(function(e, type) {
        this.transactionList = [];
        this.selected_show_time = null;
        this.selected_ssid = "";

        this.fetchTransactionDetail.transaction_date = "";
        this.fetchTransactionDetail.transaction_date_to = "";
        this.currentPage = 1;

        if (type == "from") {
          this.fetchTransactionDetail.show_date_to = new Date(e);
          this.$forceUpdate();
        }

        this.getSchedule();
      }, 500),
      onSearchFilterValues: function() {
        if (this.searchFilterValues && this.searchFilterValues.length > 0) {
          this.filterValues = this.filterValuesCopy.filter((x) => {
            // let full_name = `${x.first_name} ${x.last_name}`
            if (
              (x.username &&
                x.username
                  .toLowerCase()
                  .includes(this.searchFilterValues.toLowerCase())) ||
              (x.movie &&
                x.movie
                  .toLowerCase()
                  .includes(this.searchFilterValues.toLowerCase())) ||
              (x.screen_name &&
                x.screen_name
                  .toLowerCase()
                  .includes(this.searchFilterValues.toLowerCase()))
              // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.filterValues = this.filterValuesCopy;
        }
      },
      onSearchCinema: function(value) {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.Cinemas = this.CinemasCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Cinemas = this.CinemasCopy;
        }
      },
      onSelectDetails: function(User) {
        this.$router.push({
          path: "/user-management/view-user-audit-log",
          query: {
            user_id: User.user_id,
            login_time: User.login_date_time,
            logout_time: User.logout_date_time,
            date: this.fetchTransactionDetail.date,
          },
        });
      },

      getCinemaList: function(cine_id) {
        this.Cinemas = [];
        console.log({ cine_id });
        // let payload = {
        //   tableName: "ms_cinemas",
        //   cine_is_active: "Y"
        // };
        MasterService.GetCinemasByRoles({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasCopy = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  // this.fetchTransactionDetail.cinema_id = x.cine_id;
                  // this.selectedCinema = x.cine_name;
                  this.onSelectCinema(null, {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id,
                  });
                }

                if (
                  this.fetchTransactionDetail &&
                  this.fetchTransactionDetail.cinema_id &&
                  x.cine_id === this.fetchTransactionDetail.cinema_id
                ) {
                  this.selectedCinema = x.cine_name;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectFilter: function(event, params) {
        if (params == "clearFilter") return this.clearFilter();

        this.filterValues = [];
        this.filterValuesCopy = [];
        this.filtervalue = "";
        this.selectedFilterValue = "";
        this.selectedFilter = params;
        if (params == "User") {
          this.filterkey = "t.created_by";
          // this.getUserList(this.fetchTransactionDetail.cinema_id);
        } else if (params == "Screen") {
          this.filterkey = "screen_name";
          this.getScreens(this.fetchTransactionDetail.cinema_id);
        } else if (params == "Movie") {
          this.filterkey = "md_id";
          this.getMoviesList();
        } else if (params == "Show Booking Code") {
          this.filterkey = "sb_booking_code";
          this.clearShowDates();
          console.log(" this.filterkey :", this.filterkey);
        }

        //   this.onGetTransactionList();
      },
      getMoviesList: function() {
        this.Movies = [];
        MovieService.GetActiveMoviesWithFormat({ movieversions: "Y" })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.filterValues = data.Records;
              this.filterValuesCopy = data.Records;

              if (this.filterkey === "md_id" && this.filtervalue) {
                let movie = data.Records.find(
                  (x) => x.md_id == this.filtervalue
                );
                if (movie) {
                  this.selectedFilterValue = movie.movie;
                }
              }
            } else {
              // Show Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            console.log("Catch On GetActiveCinemas :", error);
          });
      },
      getScreens: function(cinema_id) {
        let payload = {
          tableName: "screens",
          screen_is_active: "Y",
          cinema_id: cinema_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.filterValues = data.Records;
              this.filterValuesCopy = data.Records;
            } else {
              // Shoe Error Message:
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(
              "Catch Error on getActiveScreenByCinemaId :",
              error
            );
          });
      },
      onSelectFilterValue: function(params) {
        if (params == "clearFilter") return this.clearFilter();

        if (this.selectedFilter == "User") {
          this.selectedFilterValue = params.username;
          this.filtervalue = params.user_id;
        } else if (this.selectedFilter == "Screen") {
          this.selectedFilterValue = params.screen_name;

          this.filtervalue = params.screen_name;
        } else if (this.selectedFilter == "Movie") {
          this.selectedFilterValue = params.movie;

          this.filtervalue = params.md_id;
        }
        this.searchFilterValues = "";
        this.onSearchFilterValues();
      },
      onGetTransactionList: function(type = "") {
        this.$router
          .replace({
            query: {
              // ...this.$route.query,
              cinema_id: this.fetchTransactionDetail.cinema_id,
              transaction_date: this.fetchTransactionDetail.transaction_date
                ? moment(this.fetchTransactionDetail.transaction_date).format(
                    "YYYY-MM-DD"
                  )
                : null,
              transaction_date_to: this.fetchTransactionDetail
                .transaction_date_to
                ? moment(
                    this.fetchTransactionDetail.transaction_date_to
                  ).format("YYYY-MM-DD")
                : null,
              show_date: this.fetchTransactionDetail.show_date
                ? moment(this.fetchTransactionDetail.show_date).format(
                    "YYYY-MM-DD"
                  )
                : null,
              filterkey: this.filterkey ? this.filterkey : null,
              filtervalue: this.filtervalue ? this.filtervalue : null,
              ss_id: this.selected_ssid || null,
              limit: this.perPage,
              currentPage: this.currentPage,
              searchValue: this.searchValue,
            },
          })
          .catch((err) => {
            console.log("ERROR in ROUTER REPLACE", err);
          });
        // console.log("this.$router.push", this.$route.query);

        // if(!this.fetchTransactionDetail.cinema_id) this.$toasted.show("Please select cinema")
        if (
          this.fetchTransactionDetail.show_date_to &&
          !this.fetchTransactionDetail.show_date
        )
          this.$toasted.show("Please select Show date from");
        if (
          this.fetchTransactionDetail.transaction_date_to &&
          !this.fetchTransactionDetail.transaction_date
        )
          this.$toasted.show("Please select Transaction date from");

        this.transactionList = [];
        if (this.checkValidation) {
          if (
            this.filterkey &&
            this.filterkey.length > 0 &&
            this.filtervalue.length == 0
          ) {
            this.$toasted.show("Please select or enter filter value.");
          } else {
            let loader = this.$loading.show();

            this.btenable = true;
            let payload = {
              cinema_id: this.fetchTransactionDetail.cinema_id,
              transaction_date: this.fetchTransactionDetail.transaction_date
                ? moment(this.fetchTransactionDetail.transaction_date).format(
                    "YYYY-MM-DD"
                  )
                : null,
              show_date: this.fetchTransactionDetail.show_date
                ? moment(this.fetchTransactionDetail.show_date).format(
                    "YYYY-MM-DD"
                  )
                : null,
              filterkey: this.filterkey ? this.filterkey : null,
              filtervalue: this.filtervalue ? this.filtervalue : null,
              ss_id: this.selected_ssid || null,
              limit: this.perPage,
              currentPage: this.currentPage,
              searchValue: this.searchValue,
              type: type,
              cinema_name: this.selectedCinema,
            };

            payload.transaction_date_to = this.fetchTransactionDetail
              .transaction_date_to
              ? moment(this.fetchTransactionDetail.transaction_date_to).format(
                  "YYYY-MM-DD"
                )
              : null;

            payload.show_date_to = this.fetchTransactionDetail.show_date_to
              ? moment(this.fetchTransactionDetail.show_date_to).format(
                  "YYYY-MM-DD"
                )
              : null;

            MasterService.getTransactionsByDetail(payload)
              .then((response) => {
                this.btenable = false;
                const { data } = response;
                if (data.status && data.Records && data.Records.length > 0) {
                  this.transactionList = data.Records;

                  this.transactionListCopy = data.Records;
                  if (type == "isPdfData" && data.pdfPath) {
                    window.open(data.pdfPath, "_blank");
                  }
                  if (type == "isExcelData" && data.excelPath) {
                    window.open(data.excelPath, "_blank");
                  }
                  if (data.totalRows && data.totalRows >= 10) {
                    this.rows = data.totalRows;
                    this.selectedvalue = this.perPage;
                  } else if (data.totalRows) {
                    this.rows = data.totalRows;
                    this.selectedvalue = data.totalRows;
                  }
                } else if (data.Records && data.Records.length == 0) {
                  this.rows = 0;
                  this.selectedvalue = "0";
                  this.$toasted.show("No Records Found.");
                } else {
                  this.rows = 0;
                  this.selectedvalue = "0";
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError)
              .finally(() => {
                setTimeout(() => loader.hide(), 1000);
                // this.getFnBTransactionList();
              });
          }
        } else {
          // this.$toasted.show("Please select cinema and date");
        }
      },
      onAsyncSearchUser: _.debounce(function(query) {
        if (query) {
          this.isSearchLoading = true;
          this.searchUserValue = query;
          this.searchUsers = [];
          this.getUserList(this.fetchTransactionDetail.cinema_id);
        }
      }, 1 * 1000),
      clearFilter: function() {
        this.selectedFilterValue = "";
        this.filterValues = [];
        this.filterValuesCopy = [];
        this.selectedFilter = "";
        this.selectedFilterValue = "";
        this.filterkey = "";
        this.filtervalue = "";
      },
      onSelectCinema: function(event, params) {
        this.searchCinema = "";
        this.onSearchCinema(null);
        this.$store.dispatch("selectDropdownCinema", params);
        this.selectedCinema = params.cine_name;
        this.fetchTransactionDetail.cinema_id = params.cine_id
          ? params.cine_id
          : "";
        // this.getUserList(params.cine_id);
        if (
          this.fetchTransactionDetail.show_date ||
          this.fetchTransactionDetail.transaction_date
        ) {
          // this.onGetTransactionList();
        }
        // else {
        //   this.$toasted.show("Please select date");
        // }
      },
      getUserList: function(cinema_Id) {
        this.searchUsers = [];
        let body = {
          limit: null,
          currentPage: null,
          orderby: null,
          columnName: null,
          searchValue: this.searchUserValue,
        };
        UserService.ListAllUser({}, body)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.filterValues = data.data.filter((x) => {
                if (x.cinema_id == cinema_Id) {
                  return x;
                }
              });
              this.filterValuesCopy = data.data.filter((x) => {
                if (x.cinema_id == cinema_Id) {
                  return x;
                }
              });
              this.searchUsers = data.data.filter((x) => {
                if (x.cinema_id == cinema_Id) {
                  return x;
                }
              });
            } else if (
              data.status == false &&
              data.message == "You are not authorized"
            ) {
              this.$router.push({
                path: "/access-denied",
              });
            } else {
              this.$toasted.show(data.message);
            }
            console.log("this.users :", this.users);
          })
          .catch(this._CatchError)
          .finally(() => {
            this.isSearchLoading = false;
          });
      },
      getSchedule: function() {
        if (
          !this.fetchTransactionDetail.show_date ||
          !this.fetchTransactionDetail.cinema_id
        ) {
          return;
        }
        let payload = {
          ss_show_status: 16,
          cinema_id: this.fetchTransactionDetail.cinema_id,
          start_date: moment(this.fetchTransactionDetail.show_date).format(
            "YYYY-MM-DD"
          ),
          end_date: moment(this.fetchTransactionDetail.show_date).format(
            "YYYY-MM-DD"
          ),
          groupbyssid: "Y",
        };

        if (this.fetchTransactionDetail.show_date_to)
          payload.end_date = moment(
            this.fetchTransactionDetail.show_date_to
          ).format("YYYY-MM-DD");

        let loader = this.$loading.show();

        scheduleService
          .GetCinemaSchedule(payload)
          .then((result) => {
            this.btenable = false;
            const { data } = result;

            if (data.status) {
              this.schedules = data.Records;

              if (this.selected_ssid) {
                this.schedules.forEach((schedule) => {
                  if (schedule.ss_id == this.selected_ssid) {
                    this.selected_show_time = schedule;
                  }
                });
              }
            }
          })
          .catch((err) => {
            console.log("err :", err);
          })
          .finally(() => {
            loader.hide();
          });
      },
      onSelectShowtime: function(session) {
        this.selected_show_time = session;
        this.selected_ssid = session.ss_id;
      },
      getShowtimeString: function(schedule) {
        if (!schedule) return "";

        return `${moment(schedule.ss_actual_start_date_time).format(
          "DD-MM-YYYY"
        )} ${schedule.ss_start_show_time} (${schedule.movie})`;
      },

      getFnBTransactionList: function() {
        // this.btenable = true;
        // if (this.cine_id) {
        let loader = this.$loading.show();

        let payload = {
          limit: this.fnbperPage,
          currentPage: this.fnbcurrentPage,
          search_value:
            this.fnbsearchValue.length > 0
              ? this.fnbsearchValue.replaceAll("'", "")
              : "",
          date: this.fetchTransactionDetail.transaction_date_to
            ? moment(this.fetchTransactionDetail.transaction_date_to).format(
                "YYYY-MM-DD"
              )
            : "",
          from_date: this.fetchTransactionDetail.transaction_date
            ? moment(this.fetchTransactionDetail.transaction_date).format(
                "YYYY-MM-DD"
              )
            : "",
          // date: moment(this.date).format("YYYY-MM-DD"),

          cinema_id: this.fetchTransactionDetail.cinema_id,
          bs_id: this.bs_id ? this.bs_id : "",
        };
        PosFnbService.GetFnBTransactions(payload)
          .then((response) => {
            // this.btenable = false;
            const { data } = response;

            if (data && data.status) {
              console.log("data_fnb", data);
              if (data.Records && data.Records.length > 0) {
                this.fnbtransactionList = data.Records;
                console.log("data_record", data.Records);
                console.log(
                  this.fnbtransactionList,
                  " this.fnbtransactionList "
                );
                if (data.totalRows >= 10) {
                  this.fnbRows = data.totalRows;
                  this.fnbselectedvalue =
                    this.fnbselectedvalue < 10 ? 10 : this.fnbselectedvalue;
                } else {
                  this.fnbRows = data.totalRows;
                  this.fnbselectedvalue = data.totalRows;
                }
              } else {
                this.fnbtransactionList = [];
                this.fnbRows = data.totalRows;
                this.fnbselectedvalue = data.totalRows;

                if (
                  this.showSelectedTable == "F&B Transactions" ||
                  this.showSelectedTable == "Both"
                ) {
                  this.$toasted.show("No F&B Transactions Found");
                }
              }
            } else {
              this.fnbtransactionList = [];
              // this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
        // }
        // else {
        //   this.$toasted.show("Please select a cinema");
        // }
      },
      toDetails(object) {
        this.$router.push({
          name: "View F&B Transaction",
          params: { ft_id: object.ft_id },
        });
      },
      getFnbviewingnumber: function() {
        this.fnbviewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      fnbonDropDownChangeValue(event) {
        if (event == "All") {
          console.log("event", event);
          this.fnbperPage = this.fnbRows;
          this.fnbselectedvalue = event;
          this.fnbonChangePagination();
        } else {
          console.log("Numbers :", event);
          this.fnbselectedvalue = event;
          this.fnbperPage = event;
          console.log("perPage :", this.fnbperPage);
          this.fnbonChangePagination();
        }
      },
      /* eslint-disable */
      fnbonChangePagination: function(event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          // this.getFnBTransactionList();
        } else {
          this.currentPage = event;
          // this.getFnBTransactionList();
        }
      },
      changeTableFilter(event) {
        console.log(event);
        if (event == "Transactions") {
          this.showSelectedTable = "Transactions";
        } else if (event == "F&B Transactions") {
          this.showSelectedTable = "F&B Transactions";
        } else {
          this.showSelectedTable = "Both";
        }
      },
    },
  };
</script>

<style scoped>
  .sph-report th,
  td {
    height: 30px;
  }

  .sticky-cell {
    position: sticky;
    left: 0;
    /* Adjust left value as needed */
    background-color: #f1f1f1;
    /* Optional: Adding background color */
    z-index: 1;
    /* Optional: Adding z-index to layer the sticky cell */
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/transactionComponents/transactions.vue